import { TextLayer } from "@deck.gl/layers";

export default class TextsLayer {
  constructor({ layer_id, data }) {
    this.layer_id = layer_id;
    this.data = data;
    this.layer = this.generateLayer(data);
  }

  getLayer() {
    return this.layer;
  }

  generateLayer(data) {
    return new TextLayer({
      id: this.layer_id,
      data,
      dataTransform: data => data.features,
      getText: d => `${d.id}`,
      getPosition: d => [d.geo[1], d.geo[0]],
      getColor: d => [255, 255, 255],
      getSize: d => 20,
      sizeScale: 1,
      getPixelOffset: [0, 25],
    });
  }
}
